import {
  WorkOrderItemHistoryFormValues,
  WorkOrderItemHistoryRequest,
} from '@/core/domain/workorder/WorkOrdersItems/WorkOrdersItems.types';
import { useDisclosure } from '@/hooks';
import { DateTimeFormat } from '@/utils/moment';
import { Form, Modal, ModalProps } from 'antd';
import { useState } from 'react';
import { useWorkorderDetailContext } from '../../../WorkorderDetailProvider';
import { WorkorderItem } from '../../WorkOrderItemModal';
import WorkOrderItemHistoryListModal from '../WorkOrderItemHistoryListModal';
import WorkOrderItemHistoryFilter from './WorkOrderItemHistoryFilter';

interface Props extends ModalProps {
  onCancel: () => void;
  itemPart: WorkorderItem;
}

const WorkOrderItemHistoryModal: React.FC<Props> = ({ itemPart, ...props }) => {
  const [form] = Form.useForm<WorkOrderItemHistoryFormValues>();
  const [params, setParams] = useState<WorkOrderItemHistoryRequest>();
  const [modalListOpened, modalListAction] = useDisclosure(false, {
    onClose: () => setParams(undefined),
  });

  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  function handleCancel() {
    form.resetFields();
    props.onCancel();
  }

  async function handleSubmit() {
    try {
      if (!complement || !workorder) return;

      const { hasCustomer, ...values } = await form.validateFields();

      modalListAction.open();

      setParams({
        ...values,
        partId: itemPart.itemId,
        complementId: complement.id,
        from: values.from.format(DateTimeFormat),
        to: values.to.format(DateTimeFormat),
        customerId: hasCustomer ? workorder.customer?.id : undefined,
      });
    } catch {}
  }

  return (
    <>
      <Modal
        {...props}
        onCancel={handleCancel}
        onOk={handleSubmit}
        okText="Ver histórico"
        title="Histórico da peça"
        width={700}
      >
        <WorkOrderItemHistoryFilter form={form} />
      </Modal>

      <WorkOrderItemHistoryListModal
        itemPart={itemPart}
        params={params}
        open={modalListOpened}
        onCancel={modalListAction.close}
      />
    </>
  );
};

export default WorkOrderItemHistoryModal;
